import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import genGetRequest from '../../../../helper/genGetRequest'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'
import { removeLoading, addLoading } from '../../../commonAction'
import sortListStringNum from '../../../../helper/sortLIstStringNum'

const apiGetListNumOfNotRegisterBio = `${host}admin/exportJSON/notRegisterBio`
const apiExportListNumOfNotRegisterBio = `${host}admin/export/notRegisterBio`

export const getListNumOfNotRegisterBio = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(apiGetListNumOfNotRegisterBio, dataRequest)
        const { data } = res
        dispatch({
            type: types.GET_LIST_NUM_OF_NOT_REG_BIO,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_NUM_OF_NOT_REG_BIO_ERROR,
            () => false
        )
    }
}

export const exportListNumOfNotRegisterBio = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListNumOfNotRegisterBio,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${sortListStringNum(BranchCodes).join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
